import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ILookupItem } from '../models/LookupItem';
import { Globals } from '../models/Globals';

@Injectable({
  providedIn: 'root'
})
export class AzureMapsService {
  private apiUrl = 'https://atlas.microsoft.com/search/fuzzy/json'; // Azure Maps Search API endpoint
  // private apiUrl2 = 'https://atlas.microsoft.com/search/json'; // Azure Maps Search API endpoint
  private apiUrlGeo = 'https://atlas.microsoft.com/geocode'; // Azure Maps Search API endpoint
  //private apiKey = 'D7IaIbdd6rIiyI7BfDM69sL5FL80RXhPRcB7QuoM3pWzmFm0Yj8FJQQJ99BIACYeBjF3N5qmAAAgAZMPEPXX'; // Replace with your Azure Maps key
  private apiKey = '9U25UPVOQP6lHosvmWiPBvSiDnPFrPfesacLYaWJsVVvNfwVH3Z3JQQJ99BKAC8vTInx3d5xAAAgAZMP2uPg'; // Replace with your Azure Maps key
  


  // private apiKey = '073ef76d-148c-48de-bc0a-32f30135e532'; // Replace with your Azure Maps key


  constructor(private http: HttpClient,
    private globas: Globals
  ) {
    this.apiKey = globas.key;
  }

 geocode(line: string, city: string, state: string, postal: string): Observable<any> {
    const params = new HttpParams()
      .set('subscription-key', this.apiKey)
      .set('api-version', '2025-01-01')
      //.set('query', query)
      .set('countryRegion', 'US')
      .set('addressLine', line)
      .set('adminDistrict', state)
      .set('locality', city)
      .set('postalCode', postal);


      //.set('topLeft', '41.0,-109.0')
      //.set('btmRight', '37.0,-102.0');


    //return this.http.get(this.apiUrl, { params });
    return this.http.get(this.apiUrlGeo, { params })
    //.pipe(map((response) => this.converToLookup(response)));;
    .pipe(
        //map(response =>response)
        // map(response =>this.converToLookup(response))
        // catchError(this.handleError)
      );
  }

  lookAddress(query: string): Observable<any> {
    const params = new HttpParams()
      .set('subscription-key', this.apiKey)
      .set('api-version', '1.0')
      .set('query', query)
      .set('countrySet', 'US')
      //.set('matchType', 'AddressPoint')
      .set('typeahead', 'true')
      .set('topLeft', '41.0,-109.0')
      .set('btmRight', '37.0,-102.0');


    //return this.http.get(this.apiUrl, { params });
    return this.http.get(this.apiUrl, { params })
    //.pipe(map((response) => this.converToLookup(response)));;
    .pipe(
        //map(response =>response) 
        // map(response =>this.converToLookup(response)) 
        // catchError(this.handleError)
      );
  }
  
  searchAddress(query: string): Observable<any> {
    const params = new HttpParams()
      .set('subscription-key', this.apiKey)
      .set('api-version', '1.0')
      .set('query', query)
      .set('countrySet', 'US')
      .set('matchType', 'AddressPoint')
      .set('topLeft', '41.0,-109.0')
      .set('btmRight', '37.0,-102.0');


    //return this.http.get(this.apiUrl, { params });
    return this.http.get(this.apiUrl, { params })
    //.pipe(map((response) => this.converToLookup(response)));;
    .pipe(
        //map(response =>response) 
        // map(response =>this.converToLookup(response)) 
        // catchError(this.handleError)
      );
  }

  converToLookup(r: any): any[]{
    let res:ILookupItem[] = [];

    for (const item of r.results) {
        let look:ILookupItem = {
            id: 0,
            id2: 0,
            text: item.address?.freeformAddress,
            text2: item.address?.neighbourhood || '',
            isSet: false
        };

        res.push(look);
    }
    return res;
  }
}
